"use strict";

var _regeneratorRuntime = require("/Users/ramirogonzalez/Xivis/POAP/poap-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var eccryptoJS = tslib_1.__importStar(require("eccrypto-js"));

var utils_1 = require("@walletconnect/utils");

function generateKey(length) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _length, buffer, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _length = (length || 256) / 8;
            buffer = eccryptoJS.randomBytes(_length);
            result = utils_1.convertBufferToArrayBuffer(buffer);
            return _context.abrupt("return", result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.generateKey = generateKey;

function verifyHmac(payload, key) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var cipherText, iv, hmac, hmacHex, unsigned, chmac, chmacHex;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cipherText = utils_1.convertHexToBuffer(payload.data);
            iv = utils_1.convertHexToBuffer(payload.iv);
            hmac = utils_1.convertHexToBuffer(payload.hmac);
            hmacHex = utils_1.convertBufferToHex(hmac, true);
            unsigned = utils_1.concatBuffers(cipherText, iv);
            _context2.next = 7;
            return eccryptoJS.hmacSha256Sign(key, unsigned);

          case 7:
            chmac = _context2.sent;
            chmacHex = utils_1.convertBufferToHex(chmac, true);

            if (!(utils_1.removeHexPrefix(hmacHex) === utils_1.removeHexPrefix(chmacHex))) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", true);

          case 11:
            return _context2.abrupt("return", false);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.verifyHmac = verifyHmac;

function encrypt(data, key, providedIv) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _key, ivArrayBuffer, iv, ivHex, contentString, content, cipherText, cipherTextHex, unsigned, hmac, hmacHex;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _key = utils_1.convertArrayBufferToBuffer(key);
            _context3.t0 = providedIv;

            if (_context3.t0) {
              _context3.next = 6;
              break;
            }

            _context3.next = 5;
            return generateKey(128);

          case 5:
            _context3.t0 = _context3.sent;

          case 6:
            ivArrayBuffer = _context3.t0;
            iv = utils_1.convertArrayBufferToBuffer(ivArrayBuffer);
            ivHex = utils_1.convertBufferToHex(iv, true);
            contentString = JSON.stringify(data);
            content = utils_1.convertUtf8ToBuffer(contentString);
            _context3.next = 13;
            return eccryptoJS.aesCbcEncrypt(iv, _key, content);

          case 13:
            cipherText = _context3.sent;
            cipherTextHex = utils_1.convertBufferToHex(cipherText, true);
            unsigned = utils_1.concatBuffers(cipherText, iv);
            _context3.next = 18;
            return eccryptoJS.hmacSha256Sign(_key, unsigned);

          case 18:
            hmac = _context3.sent;
            hmacHex = utils_1.convertBufferToHex(hmac, true);
            return _context3.abrupt("return", {
              data: cipherTextHex,
              hmac: hmacHex,
              iv: ivHex
            });

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.encrypt = encrypt;

function decrypt(payload, key) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _key, verified, cipherText, iv, buffer, utf8, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _key = utils_1.convertArrayBufferToBuffer(key);

            if (_key) {
              _context4.next = 3;
              break;
            }

            throw new Error("Missing key: required for decryption");

          case 3:
            _context4.next = 5;
            return verifyHmac(payload, _key);

          case 5:
            verified = _context4.sent;

            if (verified) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return", null);

          case 8:
            cipherText = utils_1.convertHexToBuffer(payload.data);
            iv = utils_1.convertHexToBuffer(payload.iv);
            _context4.next = 12;
            return eccryptoJS.aesCbcDecrypt(iv, _key, cipherText);

          case 12:
            buffer = _context4.sent;
            utf8 = utils_1.convertBufferToUtf8(buffer);
            _context4.prev = 14;
            data = JSON.parse(utf8);
            _context4.next = 21;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](14);
            return _context4.abrupt("return", null);

          case 21:
            return _context4.abrupt("return", data);

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[14, 18]]);
  }));
}

exports.decrypt = decrypt;